import { axiosBasic } from "../config/axios-common";
import OptionItem from "../models/OptionItem";

const getAllMaritalStatusOptions = () => {
  return axiosBasic.get("/sam/v1/personaldata/getallmaritalstates")
    .then(response => {
      let dateOption = response.data.map((row: any) => {

        let opton: OptionItem =
        {
          "Id": row.id,
          "Text": row.description,
          "Value": row.id
        }

        return opton;
      });
      return dateOption;
    })
    .catch(e => {
      console.log(e);
    });
};

const getAllLanguageOptions = () => {
  return axiosBasic.get("/sam/v1/language/getall").then(response => {
    let languageOption = response.data.map((row: any) => {
      let opton: OptionItem =
      {
        "Id": row.id,
        "Text": row.description,
        "Value": row.id
      }

      return opton;
    });
    return languageOption
  })
    .catch(e => {
      console.log(e)
    });
};

const GetAllColorSkinOptions = () => {
  return axiosBasic.get("/sam/v1/personaldata/GetAllColorSkin").then(response => {
    let colorSkinOption = response.data.map((row: any) => {
      let opton: OptionItem =
      {
        "Id": row.id,
        "Text": row.description,
        "Value": row.id
      }

      return opton;
    });
    return colorSkinOption
  })
    .catch(e => {
      console.log(e)
    });
};

const GetAllSexOptions = () => {
  return axiosBasic.get("/sam/v1/personaldata/GetAllSex").then(response => {
    let sexOption = response.data.map((row: any) => {
      let opton: OptionItem =
      {
        "Id": row.id,
        "Text": row.description,
        "Value": row.id
      }

      return opton;
    });
    return sexOption
  })
    .catch(e => {
      console.log(e)
    });
};

const GetAllNationality = () => {
  return axiosBasic.get("/sam/v1/personaldata/GetAllNationality").then(response => {
    let nationalityOption = response.data.map((row: any) => {
      let opton: OptionItem =
      {
        "Id": row.id,
        "Text": row.description,
        "Value": row.id
      }

      return opton;
    });
    return nationalityOption
  })
    .catch(e => {
      console.log(e)
    });
};

const exportedObject = {
  getAllMaritalStatusOptions,
  getAllLanguageOptions,
  GetAllColorSkinOptions,
  GetAllSexOptions,
  GetAllNationality
};


export default exportedObject
